import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { applyTheme, loadTheme } from "./theme";
import "./index.css";

// Before createRoot, not inside a component. ThemeButton applies it too, but by
// then React has already painted once -- and the archive visibly snapping from
// dark to cream on load is worse than either theme.
applyTheme(loadTheme());

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
